import React, { Component } from 'react';
import { bool, string, func } from 'prop-types';
import {
  Button,
  CircularProgress,
  TextField,
  Typography,
} from '@material-ui/core';

import { withAppContextHOC } from 'Scenes/_root/appContext';
import getHelperTextFromErrors from 'Services/helpers/errorText';
import validate from 'Services/validate';
import LoginErrors from './LoginErrors';
import styles from './styles.scss';

const validation = {
  email: {
    required: true,
  },
  password: {
    required: true,
  },
};

export class PractitionerLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      emailErrors: validate('', validation.email),
      emailTouched: false,
      password: '',
      passwordErrors: validate('', validation.password),
      passwordTouched: false,
      isLoggingInOut: false,
      loginErrors: null,
    };
  }

  handleFormSubmit = (event) => {
    const {
      email,
      emailErrors,
      password,
      passwordErrors,
    } = this.state;
    const {
      login,
      locationPractitionerDashboard,
    } = this.props;
    if (emailErrors || passwordErrors) return;
    event.preventDefault();
    this.setState({
      isLoggingInOut: true,
      loginErrors: null,
    }, () => {
      login(email.toLowerCase(), password, () => {
        locationPractitionerDashboard();
      }, (loginErrors) => {
        this.setState({
          isLoggingInOut: false,
          loginErrors,
        });
      });
    });
  }

  handleFieldChange = (fieldKey, event) => {
    this.setState({
      [fieldKey]: event.target.value,
      [`${fieldKey}Errors`]: validate(event.target.value, validation[fieldKey]),
      [`${fieldKey}Touched`]: true,
      loginErrors: null,
    });
  }

  handleFieldBlur = (fieldKey) => {
    this.setState({
      [`${fieldKey}Touched`]: true,
    });
  }

  handleLogout = () => {
    const {
      logout,
    } = this.props;
    this.setState({
      isLoggingInOut: true,
    }, () => {
      logout(() => {
        this.setState({
          isLoggingInOut: false,
        });
      });
    });
  };

  renderLoggedInDisplay = () => {
    const {
      isLoggingInOut,
    } = this.state;
    const {
      identityEmail,
      locationPractitionerDashboard,
    } = this.props;
    return (
      <div className={styles.practitionerLoginWrapper}>
        <div className={styles.heading}>
          <Typography variant='h2'>Login</Typography>
          <Typography variant='body1'>
            You are currently logged in
          </Typography>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            fullWidth
            color='primary'
            onClick={locationPractitionerDashboard}
            variant='contained'
          >
            Continue as {identityEmail}
          </Button>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            fullWidth
            color='primary'
            onClick={this.handleLogout}
          >
            Not you? Logout
          </Button>
          { isLoggingInOut && <CircularProgress className={styles.buttonProgress} size={24} /> }
        </div>
      </div>
    );
  };

  render() {
    const {
      email,
      emailErrors,
      emailTouched,
      password,
      passwordErrors,
      passwordTouched,
      isLoggingInOut,
      loginErrors,
    } = this.state;
    const {
      isLoggedIn,
      openTsAndCsModal,
      forgot,
    } = this.props;
    if (isLoggedIn) {
      return this.renderLoggedInDisplay();
    }
    return (
      <div className={styles.practitionerLoginWrapper}>
        <div className={styles.heading}>
          <Typography variant='h2'>Login</Typography>
          <Typography variant='body1'>
            Please enter your details below in order to begin using your TeleConsult dashboard
          </Typography>
        </div>
        <form onSubmit={this.handleFormSubmit}>
          <TextField
            autoFocus
            fullWidth
            required
            autoComplete='email'
            error={emailTouched && !!emailErrors}
            helperText={emailTouched && getHelperTextFromErrors(emailErrors)}
            label='Email'
            margin='dense'
            name='email'
            onBlur={() => this.handleFieldBlur('email')}
            onChange={(e) => this.handleFieldChange('email', e)}
            placeholder='Enter your email'
            size='small'
            type='email'
            value={email}
            variant='outlined'
          />
          <TextField
            fullWidth
            required
            autoComplete='pass'
            error={passwordTouched && !!passwordErrors}
            helperText={passwordTouched && getHelperTextFromErrors(passwordErrors)}
            label='Password'
            margin='dense'
            name='pass'
            onBlur={() => this.handleFieldBlur('password')}
            onChange={(e) => this.handleFieldChange('password', e)}
            placeholder='Enter your password'
            size='small'
            type="password"
            value={password}
            variant='outlined'
          />
          <LoginErrors
            errors={loginErrors}
          />
          <div className={styles.buttonWrapper}>
            <Button
              fullWidth
              color='primary'
              disabled={isLoggingInOut || !!emailErrors || !!passwordErrors}
              type='submit'
              variant='contained'
            >
              Login
            </Button>
            { isLoggingInOut && <CircularProgress className={styles.buttonProgress} size={24} /> }
          </div>
          <Typography className={styles.subtext} variant='body1'>
            By logging into TeleConsult you agree to our{' '}
            <Typography color='primary' component='span' onClick={openTsAndCsModal} variant='body1'>
              Terms and conditions
            </Typography>.
          </Typography>
          <Typography className={styles.subtext} variant='body1'>
            <Typography color='primary' component='span' onClick={forgot} variant='body1'>Forgot password?</Typography>
          </Typography>
        </form>
      </div>
    );
  }
}

const AppContextProps = {
  identityEmail: string,
  isLoggedIn: bool.isRequired,
  login: func.isRequired,
  logout: func.isRequired,
  forgot: func.isRequired,
};

const MapDispatchProps = {
  openTsAndCsModal: func.isRequired,
  locationPractitionerDashboard: func.isRequired,
};

PractitionerLogin.propTypes = {
  ...AppContextProps,
  ...MapDispatchProps,
};

export default withAppContextHOC([
  'forgot',
  'login',
  'logout',
  'isLoggedIn',
  'identityEmail',
])(PractitionerLogin);
